// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: kvajJ2MSr9DNMA2u1PusCw
// Component: lpfdmLwrBWTS
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import projectcss from "../blank_project/plasmic_blank_project.module.css"; // plasmic-import: kvajJ2MSr9DNMA2u1PusCw/projectcss
import sty from "./PlasmicDisabilityItem.module.css"; // plasmic-import: lpfdmLwrBWTS/css

createPlasmicElementProxy;

export const PlasmicDisabilityItem__VariantProps = new Array();

export const PlasmicDisabilityItem__ArgProps = new Array("children");

const $$ = {};

function PlasmicDisabilityItem__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <Stack__
      as={"div"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox)}
      >
        {renderPlasmicSlot({
          defaultContents: "Hearing (even with a hearing aid)",
          value: args.children
        })}
        <div
          data-plasmic-name={"ratingHolder"}
          data-plasmic-override={overrides.ratingHolder}
          className={classNames(projectcss.all, sty.ratingHolder)}
        />
      </div>
    </Stack__>
  );
}

const PlasmicDescendants = {
  root: ["root", "freeBox", "ratingHolder"],
  freeBox: ["freeBox", "ratingHolder"],
  ratingHolder: ["ratingHolder"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDisabilityItem__ArgProps,
          internalVariantPropNames: PlasmicDisabilityItem__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicDisabilityItem__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDisabilityItem";
  } else {
    func.displayName = `PlasmicDisabilityItem.${nodeName}`;
  }
  return func;
}

export const PlasmicDisabilityItem = Object.assign(
  // Top-level PlasmicDisabilityItem renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    ratingHolder: makeNodeComponent("ratingHolder"),
    // Metadata about props expected for PlasmicDisabilityItem
    internalVariantProps: PlasmicDisabilityItem__VariantProps,
    internalArgProps: PlasmicDisabilityItem__ArgProps
  }
);

export default PlasmicDisabilityItem;
/* prettier-ignore-end */
